import React, { useState } from "react";

import Button from "../Button/Button";
import Checkbox from "../Checkbox/Checkbox";

import "./JudgingScheduleFieldsModal.scss";

interface IProps {
  onDownload: (options: { include_breed: boolean; include_jump_height: boolean; include_call_name: boolean }) => void;
  onCancel: () => void;
}

const JudgingScheduleFieldsModal: React.FC<IProps> = (props) => {
  const [includeBreed, setIncludeBreed] = useState<boolean>(true);
  const [includeJumpHeight, setIncludeJumpHeight] = useState<boolean>(true);
  const [includeCallName, setIncludeCallName] = useState<boolean>(false);

  return (
    <div className="judging-schedule-fields-modal">
      <h2>Download Judge Schedule</h2>
      <p>Select which fields to include for each dog:</p>

      <div className="options">
        <Checkbox
          id="judge-schedule-armband"
          label="Armband Number (required)"
          value={true}
          disabled={true}
          onChange={() => {}}
        />
        <Checkbox
          id="judge-schedule-call-name"
          label="Call Name"
          value={includeCallName}
          onChange={() => setIncludeCallName(!includeCallName)}
        />
        <Checkbox
          id="judge-schedule-breed"
          label="Breed"
          value={includeBreed}
          onChange={() => setIncludeBreed(!includeBreed)}
        />
        <Checkbox
          id="judge-schedule-jump-height"
          label="Jump Height"
          value={includeJumpHeight}
          onChange={() => setIncludeJumpHeight(!includeJumpHeight)}
        />
      </div>

      <div className="modal-actions">
        <Button className="secondary" onClick={props.onCancel}>
          Cancel
        </Button>
        <Button
          onClick={() =>
            props.onDownload({
              include_breed: includeBreed,
              include_jump_height: includeJumpHeight,
              include_call_name: includeCallName,
            })
          }
        >
          Download
        </Button>
      </div>
    </div>
  );
};

export default JudgingScheduleFieldsModal;
